import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { OMEGA3_FREE_FROM_KEYS, OMEGA3_INGREDIENT_ROWS } from '../data/omega3Data';

const Omega3IngredientsSection = () => {
  const { t } = useTranslation();

  return (
    <section className="t-py-16 md:t-py-20">
      <div className="container !t-max-w-[1200px]">
        <div className="t-mx-auto t-max-w-[900px]">
          <h2
            className="!t-m-0 t-text-center t-text-[32px] md:t-text-[42px] t-leading-[1.1] t-text-navy"
            style={{ fontFamily: 'DM Serif Display, serif' }}
          >
            {t('Omega3_Ingredients_Title')}
          </h2>

          <div className="t-max-w-[680px] t-mx-auto t-mt-8 t-overflow-hidden t-rounded-[14px] t-border t-border-g200 t-bg-white">
            <table className="t-w-full t-border-collapse">
              <thead>
                <tr className="t-bg-navy t-text-white">
                  <th className="t-px-5 t-py-4 t-text-left t-text-[16px] t-font-semibold">
                    {t('Omega3_Ingredients_Table_Head_Dose')}
                  </th>
                  <th className="t-px-5 t-py-4 t-text-right t-text-[16px] t-font-semibold">
                    {t('Omega3_Ingredients_Table_Head_Amount')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {OMEGA3_INGREDIENT_ROWS.map((row) => (
                  <tr key={row.nameKey} className={row.isTotalRow ? 't-bg-teal-bg/45' : ''}>
                    <td
                      className={`t-border-b t-border-g200 t-px-5 t-py-3.5 t-text-[16px] ${
                        row.isTotalRow
                          ? 't-font-bold t-text-navy'
                          : row.isSubRow
                            ? 't-pl-8 t-italic t-text-g500'
                            : 't-text-g700'
                      }`}
                    >
                      {t(row.nameKey)}
                    </td>
                    <td
                      className={`t-border-b t-border-g200 t-px-5 t-py-3.5 t-text-right t-text-[16px] ${
                        row.isTotalRow ? 't-font-bold t-text-navy' : 't-text-g700'
                      }`}
                    >
                      {row.amount}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="t-max-w-[680px] t-mx-auto t-mt-6 t-rounded-[14px] t-border t-border-g200 t-bg-white t-p-5">
            <div className="t-text-[14px] t-font-[800] t-uppercase t-tracking-[0.06em] t-text-g700">
              {t('Omega3_Ingredients_FreeFrom_Title')}
            </div>
            <div className="t-mt-3 t-flex t-flex-wrap t-gap-2.5">
              {OMEGA3_FREE_FROM_KEYS.map((item) => (
                <span
                  key={item}
                  className="t-inline-flex t-items-center t-rounded-full t-bg-teal-bg t-px-3 t-py-1.5 t-text-[14px] t-font-semibold t-text-navy"
                >
                  {t(item)}
                </span>
              ))}
            </div>
          </div>

          <p className="t-max-w-[680px] t-mx-auto t-mt-5 t-text-[17px] t-leading-[1.7] t-text-g500">
            <Trans
              i18nKey="Omega3_Ingredients_NoteHtml"
              components={{ strong: <strong className="t-text-navy" /> }}
            />
          </p>
        </div>
      </div>
    </section>
  );
};

export default Omega3IngredientsSection;
